import Class from './c-custom-component';
import './c-custom-component@';

export default Class;